import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  favoriteModalOpened: false,
  favoriteList: null,
  isFavoritedListing: false,
  lastRemovedGroupInfo:
    null /* WHY? --> because we need the groupId information when the 'Undo' button that appears after deleting the favorite feature of a listing is clicked. */,
  favoriteInfoBarButtonContent: "",
};

export const favorite = createSlice({
  name: "favorite",
  initialState,
  reducers: {
    handleFavoriteModalOpened: (state, action) => {
      state.favoriteModalOpened = !state.favoriteModalOpened;
    },
    setFavoriteList: (state, action) => {
      state.favoriteList = action.payload;
    },
    handleListingFavorited: (state, action) => {
      state.isFavoritedListing = action.payload;
    },
    handleLastRemovedGroupInfo: (state, action) => {
      state.lastRemovedGroupInfo = action.payload;
    },
    handleFavoriteInfoBarButtonContent: (state, action) => {
      state.favoriteInfoBarButtonContent = action.payload;
    },
  },
});

export const {
  handleFavoriteModalOpened,
  setFavoriteList,
  handleListingFavorited,
  handleLastRemovedGroupInfo,
  handleFavoriteInfoBarButtonContent,
} = favorite.actions;

export default favorite.reducer;
